import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {useShallow} from 'zustand/react/shallow';

import {CodeEditor} from '../../CodeEditor';
import {ConfigKey} from '../ConfigKey';
import {useTriggerTemplateVariables} from '../hooks/useTriggerTemplateVariables';
import {useActionConfigStore} from './ActionStore';
import * as S from './CreateTriggerDrawerLoaded.styles';
import {useEventStore} from './EventStore';

export const ARIAConfiguration: React.FC = () => {
  const eventType = useEventStore(s => s.eventType);
  const templateStrings = useTriggerTemplateVariables(eventType);
  const setARIAPrompt = useActionConfigStore(s => s.setARIAPrompt);
  const {prompt, promptError} = useActionConfigStore(useShallow(s => s.aria));

  const insertTemplateString = (templateString: string) => {
    const next =
      prompt.trim().length === 0
        ? templateString
        : `${prompt}${prompt.endsWith(' ') ? '' : ' '}${templateString}`;
    setARIAPrompt(next);
  };

  return (
    <>
      <S.LabelRow>
        <S.Label>Prompt</S.Label>
      </S.LabelRow>
      {/* CodeEditor (same as webhook payload): bordered box that stays inside
          the drawer’s 2px focus padding. minHeight keeps an empty prompt usable. */}
      <CodeEditor
        value={prompt}
        language="markdown"
        onChange={setARIAPrompt}
        minHeight={120}
        maxHeight={240}
      />
      {promptError && <S.Error>{promptError}</S.Error>}
      <S.PlainText>
        Use template keys to insert event details into the prompt. Click a key
        to append it.
      </S.PlainText>
      <Tailwind>
        {templateStrings.map(ts => (
          <S.TemplateHelperRow key={ts.value}>
            <S.TemplateHelperKey>
              <ConfigKey
                configKey={ts.value}
                onPlusClick={() => insertTemplateString(ts.value)}
              />
            </S.TemplateHelperKey>
            <S.TemplateHelperString>{ts.help}</S.TemplateHelperString>
          </S.TemplateHelperRow>
        ))}
      </Tailwind>
    </>
  );
};
